
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.543 20.896l.707.708L11.604 11.25 1.25.896l-.707.708 9.646 9.646z"}})])
          )
        }
      }
    